import { useState, useEffect } from "react";
import { useMessages } from "../context/MessagesContext";
import { Shield, Star } from "lucide-react";
import "swiper/css";

import hero1 from "../assets/hero/1.webp";
import hero2 from "../assets/hero/2.webp";
import hero3 from "../assets/hero/3.webp";
import hero4 from "../assets/hero/4.webp";
import hero5 from "../assets/hero/5.webp";
import hero6 from "../assets/hero/6.webp";
import hero7 from "../assets/hero/7.webp";
import hero8 from "../assets/hero/8.webp";

const images = [hero1, hero2, hero3, hero4, hero5, hero6, hero7, hero8];

const HeroSection = () => {
  const labels = useMessages();
  const [index, setIndex] = useState(0);

  // 🚀 Preload imágenes
  useEffect(() => {
    const nextIndex = (index + 1) % images.length;
    const img = new Image();
    img.src = images[nextIndex];
  }, [index]);

  // ⏱️ Autoplay cada 4s
  useEffect(() => {
    const interval = setInterval(
      () => setIndex((prev) => (prev + 1) % images.length),
      4000
    );
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="inicio" className="relative flex">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-2 mb-6 drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)]">
              <Shield className="w-6 h-6 text-blue-400 fill-current stroke-gray" />
              <span className="text-gray-800 font-medium">
                {labels["hero.treatments"]}
              </span>
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-slate-700 mb-6 leading-tight tracking-tight">
              {labels["hero.slogan"]}
            </h1>

            <div className="space-y-4 mb-8">
              <h2 className="text-sm sm:text-base md:text-lg lg:text-xl font-normal text-slate-600 leading-relaxed max-w-2xl mx-auto lg:mx-0">
                {labels["hero.firstLabel"]}
              </h2>

              <h2 className="text-sm sm:text-base md:text-lg lg:text-xl font-normal text-slate-600 leading-relaxed max-w-2xl mx-auto lg:mx-0">
                {labels["hero.secondLabel"]}
              </h2>

              <h2 className="text-sm sm:text-base md:text-lg lg:text-xl font-normal text-slate-600 leading-relaxed max-w-2xl mx-auto lg:mx-0">
                {labels["hero.thirdLabel"]}
              </h2>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-6 mt-12">
              <div className="flex items-center gap-2">
                <Star className="w-5 h-5 text-yellow-400 fill-current" />
                <span className="text-primary-foreground/90 font-medium">
                  {labels["hero.rating"]}
                </span>
              </div>
              <div className="text-primary-foreground/70">•</div>
              <span className="text-primary-foreground/90">
                {labels["hero.punctuation"]}
              </span>
            </div>
          </div>

          {/* Slideshow */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            {/* Overlay de fondo (no tapa imágenes) */}
            <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent -z-10" />

            <section className="relative w-full h-[80vh] overflow-hidden">
              {images.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`${labels["hero.imageAlt"] || "Hidromed MX sueroterapia en Tijuana"} ${i + 1}`}
                  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${i === index ? "opacity-100" : "opacity-0"
                    }`}
                  loading={i === 0 ? "eager" : "lazy"}
                  fetchPriority={i === 0 ? "high" : "auto"}
                />
              ))}

              {/* 🔘 Dots de navegación */}
              <div className="absolute bottom-4 w-full flex justify-center gap-2 z-10">
                {images.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setIndex(i)}
                    className={`w-3 h-3 rounded-full transition ${i === index ? "bg-blue-400" : "bg-gray-400"
                      }`}
                  />
                ))}
              </div>
            </section>

          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
